<script>
  import conciliacaoProjetoServico from '../servico';

  const PAPEIS = {
    principal: 'Câmbio',
    tarifa: 'Tarifa',
    iof: 'IOF',
    irrf: 'IRRF',
    unico: 'Valor',
  };

  export default {
    data() {
      return {
        modelos: [],
        modelo: '',
        arquivo: null,
        previa: null,
        lendo: false,
        aplicando: false,
        erro: '',
        marcados: {},
        escolhas: {},
        abertosAtuais: {},
        recolhidos: {},
        confirmando: false,
        busca: null,
        requisicao: 0,
      };
    },
    computed: {
      blocos() { return (this.previa && this.previa.blocos) || []; },
      modeloAtual() { return this.modelos.find(m => m.codigo === this.modelo) || null; },
      prontos() { return this.blocos.filter(b => b.aplicavel); },
      pendentes() { return this.blocos.filter(b => !b.aplicavel); },
      selecionados() { return this.blocos.filter(b => b.aplicavel && this.marcados[b.indice]); },
      lancamentosSelecionados() { return this.selecionados.reduce((t, b) => t + b.lancamentos.length, 0); },
      valorSelecionado() { return this.selecionados.reduce((t, b) => t + b.lancamentos.reduce((s, l) => s + (+l.valor || 0), 0), 0); },
      rateiosSubstituidos() { return this.selecionados.reduce((t, b) => t + b.lancamentos.reduce((s, l) => s + l.rateiosAtuais.length, 0), 0); },
      valorProntos() { return this.prontos.reduce((t, b) => t + b.lancamentos.reduce((s, l) => s + (+l.valor || 0), 0), 0); },
    },
    mounted() {
      conciliacaoProjetoServico.modelosRateioPlanilha()
        .then(modelos => {
          this.modelos = modelos || [];
          if (this.modelos.length) this.modelo = this.modelos[0].codigo;
        })
        .catch(() => { this.erro = 'Não foi possível carregar os modelos de planilha.'; });
    },
    methods: {
      moeda(v) { return (+v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
      numero(v) { return (+v || 0).toLocaleString('pt-BR'); },
      papelTexto(p) { return PAPEIS[p] || p; },
      escolherArquivo() { this.$refs.arquivo.value = ''; this.$refs.arquivo.click(); },
      aoEscolherArquivo(e) {
        const arquivo = e.target.files && e.target.files[0];
        if (!arquivo) return;
        this.arquivo = arquivo;
        this.escolhas = {};
        this.ler();
      },
      aoTrocarModelo() {
        this.escolhas = {};
        if (this.arquivo) this.ler();
      },
      listaEscolhas() {
        return Object.keys(this.escolhas).map(k => ({ indice: +k, idLancamento: this.escolhas[k] }));
      },
      ler() {
        if (!this.arquivo || !this.modelo) return;
        const n = ++this.requisicao;
        this.lendo = true;
        this.erro = '';
        conciliacaoProjetoServico.lerRateioPlanilha(this.modelo, this.arquivo, this.listaEscolhas())
          .then(previa => {
            if (n !== this.requisicao) return;
            this.previa = previa;
            const marcados = {};
            (previa.blocos || []).forEach(b => { marcados[b.indice] = b.aplicavel; });
            this.marcados = marcados;
            this.abertosAtuais = {};
            this.lendo = false;
          })
          .catch(res => {
            if (n !== this.requisicao) return;
            this.lendo = false;
            this.previa = null;
            this.erro = res && res.body && res.body.message ? res.body.message : 'Não foi possível ler a planilha.';
          });
      },
      alternar(b) {
        if (!b.aplicavel) return;
        this.$set(this.marcados, b.indice, !this.marcados[b.indice]);
      },
      recolher(b) { this.$set(this.recolhidos, b.indice, !this.recolhidos[b.indice]); },
      verAtuais(b, l) {
        const chave = b.indice + '-' + l.idLancamento;
        this.$set(this.abertosAtuais, chave, !this.abertosAtuais[chave]);
      },
      papeisColunas(b) { return b.papeis || []; },
      valorLinha(linha, papel) {
        const v = (linha.valores || []).find(x => x.papel === papel);
        return v ? v.valor : 0;
      },
      ajusteLinha(linha, papel) {
        const v = (linha.valores || []).find(x => x.papel === papel);
        return v ? +v.ajuste || 0 : 0;
      },
      parRubrica(linha, papel) {
        return (linha.rubricas || []).find(r => r.papel === papel) || {};
      },
      papelDespesa(b) { return (b.papeis || []).find(p => p !== 'principal' && p !== 'unico') || ''; },
      somaColuna(b, papel) { return b.linhas.reduce((t, l) => t + (+this.valorLinha(l, papel) || 0), 0); },
      lancamentoDoPapel(b, papel) { return b.lancamentos.find(l => l.papel === papel) || null; },
      totalPlanilha(b) {
        const papel = (b.papeis || [])[0];
        return papel ? this.somaColuna(b, papel) : 0;
      },
      dataBusca(b) { return b.dataPagamento || ''; },
      abrirBusca(b) {
        this.busca = { indice: b.indice, titulo: b.titulo, valor: this.moeda(this.totalPlanilha(b)), data: this.dataBusca(b), texto: '', resultados: null, buscando: false, erro: '' };
        this.buscar();
      },
      valorBusca() {
        const texto = ('' + (this.busca.valor || '')).replace(/\./g, '').replace(',', '.').trim();
        return texto === '' || isNaN(+texto) ? '' : texto;
      },
      dataBuscaIso() {
        const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec((this.busca.data || '').trim());
        return m ? m[3] + '-' + m[2] + '-' + m[1] : '';
      },
      buscar() {
        const busca = this.busca;
        busca.buscando = true;
        busca.erro = '';
        conciliacaoProjetoServico.lancamentosRateioPlanilha(this.valorBusca(), this.dataBuscaIso(), busca.texto)
          .then(r => { busca.resultados = r || []; busca.buscando = false; })
          .catch(res => {
            busca.buscando = false;
            busca.resultados = [];
            busca.erro = res && res.body && res.body.message ? res.body.message : 'Não foi possível buscar os lançamentos.';
          });
      },
      escolherLancamento(c) {
        this.$set(this.escolhas, this.busca.indice, c.idLancamento);
        this.busca = null;
        this.ler();
      },
      aplicar() {
        if (!this.selecionados.length) { toastr.warning('Marque pelo menos um bloco pronto para aplicar.'); return; }
        this.confirmando = true;
      },
      confirmarAplicacao() {
        this.confirmando = false;
        this.aplicando = true;
        const escolhas = this.selecionados.map(b => {
          const assinaturas = {};
          b.lancamentos.forEach(l => { assinaturas[l.idLancamento] = l.assinatura; });
          return { indice: b.indice, idLancamento: b.lancamentos[0].idLancamento, assinaturas };
        });
        conciliacaoProjetoServico.aplicarRateioPlanilha(this.modelo, this.arquivo, escolhas)
          .then(r => {
            this.aplicando = false;
            if (r.lancamentos > 0) {
              toastr.success('Rateio aplicado: ' + this.numero(r.blocos) + ' bloco(s) · ' + this.numero(r.lancamentos)
                + ' lançamento(s) · ' + this.numero(r.rateios) + ' rateio(s) gravado(s)');
              this.$emit('aplicado');
            }
            if (r.pulados && r.pulados.length) toastr.warning('Não aplicado: ' + r.pulados.join(' · '));
            this.ler();
          })
          .catch(res => {
            this.aplicando = false;
            toastr.error(res && res.body && res.body.message ? res.body.message : 'Não foi possível aplicar o rateio.');
            this.ler();
          });
      },
    },
  };
</script>

<template>
  <div class="rp-ov">
    <div class="rp-modal">
      <div class="rp-head">
        <h4>Rateio por planilha</h4>
        <small>Troca os rateios do lançamento pelos da planilha. O lançamento não é alterado; a soma de cada coluna tem que chegar no valor dele.</small>
      </div>

      <div class="rp-filtros">
        <div class="rp-filtro">
          <label class="rp-lbl">Modelo da planilha</label>
          <select class="form-control input-sm rp-sel" v-model="modelo" @change="aoTrocarModelo">
            <option v-for="m in modelos" :key="m.codigo" :value="m.codigo">{{ m.nome }}</option>
          </select>
        </div>
        <div class="rp-filtro">
          <label class="rp-lbl">Arquivo</label>
          <div class="rp-arq">
            <button type="button" class="btn btn-default btn-sm" @click="escolherArquivo"><i class="fa fa-file-excel-o"></i> {{ arquivo ? 'Trocar planilha' : 'Escolher planilha' }}</button>
            <span class="rp-arq-nome" :title="arquivo ? arquivo.name : ''">{{ arquivo ? arquivo.name : 'nenhum arquivo escolhido' }}</span>
            <input ref="arquivo" type="file" accept=".xlsx" class="rp-oculto" @change="aoEscolherArquivo">
          </div>
        </div>
        <span class="rp-modelo-txt" v-if="modeloAtual"><i v-if="lendo" class="fa fa-spinner fa-pulse"></i> {{ modeloAtual.descricao }}</span>
      </div>

      <div v-if="previa && !lendo && blocos.length" class="rp-cards">
        <div class="rp-card">
          <div class="rp-card-lbl">Blocos na planilha</div>
          <div class="rp-card-num">{{ numero(blocos.length) }}</div>
          <div class="rp-card-obs">{{ previa.nomeArquivo }}</div>
        </div>
        <div class="rp-card" :class="prontos.length ? 'rp-card-ok' : ''">
          <div class="rp-card-lbl">Prontos para aplicar</div>
          <div class="rp-card-num">{{ numero(prontos.length) }}</div>
          <div class="rp-card-obs">R$ {{ moeda(valorProntos) }} em {{ numero(prontos.reduce((t, b) => t + b.lancamentos.length, 0)) }} lançamento(s)</div>
        </div>
        <div class="rp-card" :class="pendentes.length ? 'rp-card-alerta' : ''">
          <div class="rp-card-lbl">Com pendência</div>
          <div class="rp-card-num">{{ numero(pendentes.length) }}</div>
          <div class="rp-card-obs">{{ pendentes.length ? 'corrija a planilha ou escolha o lançamento' : 'nenhuma pendência' }}</div>
        </div>
        <div class="rp-card">
          <div class="rp-card-lbl">Linhas lidas</div>
          <div class="rp-card-num">{{ numero(blocos.reduce((t, b) => t + b.linhas.length, 0)) }}</div>
          <div class="rp-card-obs">{{ numero(blocos.reduce((t, b) => t + b.linhas.filter(l => l.erros.length).length, 0)) }} com erro de cadastro</div>
        </div>
      </div>

      <div class="rp-corpo">
        <div v-if="lendo" class="rp-msg"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>
        <div v-else-if="erro" class="rp-msg rp-erro"><i class="fa fa-exclamation-triangle"></i> {{ erro }}</div>
        <div v-else-if="!arquivo" class="rp-msg rp-vazio">
          <i class="fa fa-table fa-2x"></i>
          <p>Escolha o modelo e a planilha. O sistema lê os blocos, acha os lançamentos pelo valor e pela data e confere projeto, rubrica e subrubrica de cada linha.</p>
        </div>
        <div v-else-if="previa && previa.erros && previa.erros.length && !blocos.length" class="rp-msg rp-erro">
          <div v-for="(e, i) in previa.erros" :key="'pe' + i"><i class="fa fa-exclamation-triangle"></i> {{ e }}</div>
        </div>

        <template v-else-if="previa">
          <div v-for="b in blocos" :key="'b' + b.indice" class="rp-bloco" :class="{ pronto: b.aplicavel, pendente: !b.aplicavel, sel: marcados[b.indice] }">
            <div class="rp-bloco-cab">
              <input type="checkbox" :checked="!!marcados[b.indice]" :disabled="!b.aplicavel" @change="alternar(b)" :title="b.aplicavel ? 'Aplicar este bloco' : 'Bloco com pendência'">
              <div class="rp-bloco-tit" @click="recolher(b)">
                <b>{{ b.titulo }}</b>
                <span v-if="b.identificacao" class="rp-ident mono">{{ b.identificacao }}</span>
                <span class="rp-linha-excel">linha {{ b.linhaExcel }} da planilha</span>
              </div>
              <span class="rp-sit" :class="b.aplicavel ? 'rp-sit-ok' : 'rp-sit-pend'">
                <i class="fa" :class="b.aplicavel ? 'fa-check' : 'fa-ban'"></i> {{ b.aplicavel ? 'Pronto' : 'Pendente' }}
              </span>
              <span v-if="b.escolhidoManual" class="rp-tag">escolhido à mão</span>
              <span v-else-if="b.sugerido" class="rp-tag">sugerido pelo valor</span>
              <button type="button" class="btn btn-default btn-xs" @click="abrirBusca(b)"><i class="fa fa-search"></i> {{ b.lancamentos.length ? 'Trocar lançamento' : 'Escolher lançamento' }}</button>
              <button type="button" class="rp-exp" :title="recolhidos[b.indice] ? 'Mostrar' : 'Recolher'" @click="recolher(b)"><i class="fa" :class="recolhidos[b.indice] ? 'fa-chevron-down' : 'fa-chevron-up'"></i></button>
            </div>

            <template v-if="!recolhidos[b.indice]">
              <div v-if="b.conferencias.length" class="rp-conf">
                <div v-for="(c, i) in b.conferencias" :key="'c' + i" class="rp-conf-item" :class="c.informativo ? 'info' : (c.confere ? 'ok' : 'nao')"
                     :title="c.planilha ? 'Planilha: ' + c.planilha + '\nSistema: ' + c.sistema : c.sistema">
                  <i class="fa" :class="c.informativo ? 'fa-info-circle' : (c.confere ? 'fa-check' : 'fa-exclamation-triangle')"></i>
                  <span class="rp-conf-lbl">{{ c.rotulo }}</span>
                  <span class="rp-conf-val">{{ c.sistema || c.planilha }}</span>
                </div>
              </div>

              <div v-if="b.erros.length || b.avisos.length" class="rp-msgs">
                <div v-for="(e, i) in b.erros" :key="'e' + i" class="rp-msg-erro"><i class="fa fa-ban"></i> {{ e }}</div>
                <div v-for="(a, i) in b.avisos" :key="'a' + i" class="rp-msg-aviso"><i class="fa fa-exclamation-triangle"></i> {{ a }}</div>
              </div>

              <table v-if="b.lancamentos.length" class="rp-tab rp-tab-lanc">
                <colgroup>
                  <col style="width: 84px"><col style="width: 72px"><col style="width: 92px"><col><col style="width: 200px">
                  <col style="width: 104px"><col style="width: 104px"><col style="width: 220px"><col style="width: 130px">
                </colgroup>
                <thead>
                  <tr>
                    <th>Lançamento</th>
                    <th>Tipo</th>
                    <th>Data</th>
                    <th>Histórico</th>
                    <th>Documento</th>
                    <th class="r">Valor</th>
                    <th class="r">Planilha</th>
                    <th>Rateio atual</th>
                    <th>Situação</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="l in b.lancamentos">
                    <tr :key="'l' + l.idLancamento">
                      <td class="mono b">{{ l.idLancamento }}</td>
                      <td>{{ l.papelTexto }}</td>
                      <td class="mono">{{ l.dataTexto || '—' }}</td>
                      <td class="hist" :title="l.historico">{{ l.historico }}</td>
                      <td class="hist curto" :title="l.documento">{{ l.documento || '—' }}</td>
                      <td class="r mono b rp-amarelo">{{ moeda(l.valor) }}</td>
                      <td class="r mono" :class="Math.abs((+l.somaPlanilha || 0) - (+l.valor || 0)) < 0.005 ? 'ok' : 'ruim'">{{ moeda(l.somaPlanilha) }}</td>
                      <td>
                        <a href="#" class="rp-link" @click.prevent="verAtuais(b, l)">{{ numero(l.rateiosAtuais.length) }} linha(s) — será substituído <i class="fa" :class="abertosAtuais[b.indice + '-' + l.idLancamento] ? 'fa-caret-up' : 'fa-caret-down'"></i></a>
                      </td>
                      <td>
                        <span v-if="l.bloqueio" class="rp-sit rp-sit-pend" :title="l.bloqueio"><i class="fa fa-lock"></i> Bloqueado</span>
                        <span v-else class="rp-sit rp-sit-neutro">{{ l.pago ? 'Pago' : 'Em aberto' }}{{ l.conferido ? ' · conferido' : '' }}</span>
                      </td>
                    </tr>
                    <tr v-if="abertosAtuais[b.indice + '-' + l.idLancamento]" :key="'la' + l.idLancamento" class="rp-atuais">
                      <td colspan="9">
                        <table class="rp-tab rp-tab-atual">
                          <thead><tr><th>Projeto</th><th>Rubrica</th><th>Subrubrica</th><th class="r">Valor</th></tr></thead>
                          <tbody>
                            <tr v-for="r in l.rateiosAtuais" :key="'r' + r.idLancRateio">
                              <td class="hist" :title="r.projeto">{{ r.projeto }}</td>
                              <td>{{ r.rubrica }}</td>
                              <td>{{ r.subRubrica }}</td>
                              <td class="r mono">{{ moeda(r.valor) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>

              <table class="rp-tab rp-tab-linhas">
                <colgroup>
                  <col style="width: 54px"><col style="width: 118px"><col><col style="width: 118px"><col style="width: 128px">
                  <col v-if="papelDespesa(b)" style="width: 128px">
                  <col v-for="p in papeisColunas(b)" :key="'cg' + p" :style="{ width: papeisColunas(b).length > 1 ? '96px' : '120px' }">
                  <col style="width: 150px">
                </colgroup>
                <thead>
                  <tr>
                    <th class="r">Linha</th>
                    <th>{{ previa.modelo === 'cambio' ? 'Curso' : 'Código' }}</th>
                    <th>Projeto</th>
                    <th>Rubrica</th>
                    <th>Subrubrica</th>
                    <th v-if="papelDespesa(b)" title="Subrubrica da tarifa, do IOF e do IRRF">Sub. despesas</th>
                    <th v-for="p in papeisColunas(b)" :key="'h' + p" class="r">{{ papelTexto(p) }}</th>
                    <th>Situação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="x in b.linhas" :key="'x' + x.linhaExcel" :class="{ 'rp-linha-erro': x.erros.length }">
                    <td class="r mono mudo">{{ x.linhaExcel }}</td>
                    <td class="mono" :title="x.info">{{ x.rotulo }}</td>
                    <td class="hist" :title="x.projeto">{{ x.projeto || '—' }}</td>
                    <td class="hist curto" :title="parRubrica(x, papeisColunas(b)[0]).rubrica">{{ parRubrica(x, papeisColunas(b)[0]).rubrica || '—' }}</td>
                    <td class="hist curto" :title="parRubrica(x, papeisColunas(b)[0]).subRubrica">{{ parRubrica(x, papeisColunas(b)[0]).subRubrica || '—' }}</td>
                    <td v-if="papelDespesa(b)" class="hist curto" :title="parRubrica(x, papelDespesa(b)).rubrica + ' / ' + parRubrica(x, papelDespesa(b)).subRubrica">{{ parRubrica(x, papelDespesa(b)).subRubrica || '—' }}</td>
                    <td v-for="p in papeisColunas(b)" :key="'v' + p" class="r mono" :class="{ 'rp-ajustado': ajusteLinha(x, p) }"
                        :title="ajusteLinha(x, p) ? 'Inclui ajuste de arredondamento de R$ ' + moeda(ajusteLinha(x, p)) + ' para fechar no valor do lançamento' : ''">{{ moeda(valorLinha(x, p)) }}<sup v-if="ajusteLinha(x, p)">*</sup></td>
                    <td class="rp-td-sit">
                      <span v-if="x.erros.length" class="rp-erro-linha" :title="x.erros.join('\n')"><i class="fa fa-ban"></i> {{ x.erros[0] }}<template v-if="x.erros.length > 1"> (+{{ x.erros.length - 1 }})</template></span>
                      <span v-else class="ok"><i class="fa fa-check"></i></span>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td :colspan="papelDespesa(b) ? 6 : 5" class="r rp-tot-lbl">Soma dos rateios</td>
                    <td v-for="p in papeisColunas(b)" :key="'t' + p" class="r mono b">{{ moeda(somaColuna(b, p)) }}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td :colspan="papelDespesa(b) ? 6 : 5" class="r rp-tot-lbl">Valor do lançamento</td>
                    <td v-for="p in papeisColunas(b)" :key="'tl' + p" class="r mono b rp-amarelo">{{ lancamentoDoPapel(b, p) ? moeda(lancamentoDoPapel(b, p).valor) : '—' }}</td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </template>
          </div>
        </template>
      </div>

      <div class="rp-foot">
        <div class="rp-foot-info">
          <template v-if="selecionados.length">
            {{ numero(selecionados.length) }} bloco(s) marcado(s) · {{ numero(lancamentosSelecionados) }} lançamento(s) · R$ {{ moeda(valorSelecionado) }}
          </template>
          <template v-else-if="previa && !lendo">Nenhum bloco marcado.</template>
        </div>
        <div class="rp-acoes">
          <button type="button" class="btn btn-success" :disabled="aplicando || lendo || !selecionados.length" @click="aplicar">
            <i class="fa" :class="aplicando ? 'fa-spinner fa-pulse' : 'fa-sitemap'"></i> {{ aplicando ? 'Aplicando...' : 'Aplicar rateio (' + selecionados.length + ')' }}
          </button>
          <button type="button" class="btn rd-sair" :disabled="aplicando" @click="$emit('fechar')"><i class="fa fa-sign-out"></i> Sair</button>
        </div>
      </div>

      <div v-if="busca" class="rp-conf-ov">
        <div class="rp-dlg rp-dlg-busca">
          <h5><i class="fa fa-search"></i> Escolher lançamento · {{ busca.titulo }}</h5>
          <div class="rp-busca-filtros">
            <div class="rp-filtro">
              <label class="rp-lbl">Valor</label>
              <input class="form-control input-sm" v-model="busca.valor" @keyup.enter="buscar">
            </div>
            <div class="rp-filtro">
              <label class="rp-lbl">Data (±60 dias)</label>
              <input class="form-control input-sm" v-model="busca.data" placeholder="dd/mm/aaaa" @keyup.enter="buscar">
            </div>
            <div class="rp-filtro rp-filtro-largo">
              <label class="rp-lbl">Nº do lançamento ou texto do histórico/documento</label>
              <input class="form-control input-sm" v-model="busca.texto" @keyup.enter="buscar">
            </div>
            <button type="button" class="btn btn-primary btn-sm" :disabled="busca.buscando" @click="buscar"><i class="fa" :class="busca.buscando ? 'fa-spinner fa-pulse' : 'fa-search'"></i> Buscar</button>
          </div>
          <div class="rp-busca-res">
            <div v-if="busca.erro" class="rp-msg rp-erro">{{ busca.erro }}</div>
            <div v-else-if="busca.resultados && !busca.resultados.length" class="rp-msg">Nenhum lançamento de débito encontrado.</div>
            <table v-else-if="busca.resultados" class="rp-tab">
              <thead><tr><th>Lançamento</th><th>Data</th><th>Histórico</th><th>Documento</th><th>Conta</th><th class="r">Rateios</th><th class="r">Valor</th><th></th></tr></thead>
              <tbody>
                <tr v-for="c in busca.resultados" :key="'bc' + c.idLancamento" class="rp-linha-click" @click="escolherLancamento(c)">
                  <td class="mono b">{{ c.idLancamento }}</td>
                  <td class="mono">{{ c.dataTexto || '—' }}</td>
                  <td class="hist" :title="c.historico">{{ c.historico }}</td>
                  <td class="hist curto" :title="c.documento">{{ c.documento || '—' }}</td>
                  <td class="hist curto" :title="c.conta">{{ c.conta }}</td>
                  <td class="r mono">{{ numero(c.rateios) }}</td>
                  <td class="r mono b">{{ moeda(c.valor) }}</td>
                  <td><button type="button" class="btn btn-success btn-xs">Escolher</button></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="rp-dlg-acoes">
            <button type="button" class="btn rd-sair" @click="busca = null"><i class="fa fa-sign-out"></i> Voltar</button>
          </div>
        </div>
      </div>

      <div v-if="confirmando" class="rp-conf-ov">
        <div class="rp-dlg">
          <h5><i class="fa fa-sitemap"></i> Aplicar o rateio da planilha</h5>
          <p>Os {{ numero(rateiosSubstituidos) }} rateio(s) atuais dos lançamentos abaixo serão apagados e substituídos pelos da planilha. Valor, conta, data e histórico dos lançamentos não mudam.</p>
          <ul class="rp-dlg-lista">
            <li v-for="b in selecionados" :key="'cf' + b.indice">
              <b>{{ b.titulo }}</b> <span class="mono">{{ b.identificacao }}</span>
              <small>{{ b.lancamentos.map(l => l.papelTexto + ' ' + l.idLancamento + ' (R$ ' + moeda(l.valor) + ')').join(' · ') }}</small>
            </li>
          </ul>
          <p class="rp-dlg-perg">Confirma a aplicação em {{ numero(lancamentosSelecionados) }} lançamento(s)?</p>
          <div class="rp-dlg-acoes">
            <button type="button" class="btn btn-success" @click="confirmarAplicacao"><i class="fa fa-sitemap"></i> Aplicar</button>
            <button type="button" class="btn rd-sair" @click="confirmando = false"><i class="fa fa-sign-out"></i> Voltar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .rp-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.55); z-index: 2100; display: flex; align-items: center; justify-content: center; }
  .rp-modal { position: relative; width: 1360px; max-width: 97vw; height: 90vh; display: flex; flex-direction: column; background: #fff; border-radius: 8px; box-shadow: 0 16px 48px rgba(16,24,40,.35); overflow: hidden; }
  .rp-head { flex: 0 0 auto; padding: 14px 18px 10px; border-bottom: 1px solid #eceef1; }
  .rp-head h4 { margin: 0; font-size: 16px; font-weight: 600; color: #1c2024; }
  .rp-head small { display: block; color: #8a939c; font-size: 12px; margin-top: 3px; }
  .mono { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; }
  .mudo { color: #9aa3ac; }
  .ok { color: #0a6d4d; }
  .ruim { color: #c0392b; }
  .rp-oculto { display: none; }

  .rp-filtros { flex: 0 0 auto; display: flex; align-items: flex-end; flex-wrap: wrap; gap: 8px 16px; padding: 10px 18px; border-bottom: 1px solid #eceef1; background: #fbfcfd; }
  .rp-filtro { display: flex; flex-direction: column; gap: 4px; }
  .rp-filtro-largo { flex: 1 1 260px; }
  .rp-lbl { font-size: 11px; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; font-weight: 600; margin: 0; }
  .rp-sel { height: 30px; min-width: 240px; font-size: 12.5px; }
  .rp-arq { display: flex; align-items: center; gap: 8px; height: 30px; }
  .rp-arq .btn { height: 30px; }
  .rp-arq-nome { font-size: 12.5px; color: #34495e; max-width: 320px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .rp-modelo-txt { font-size: 12px; color: #6b747e; margin-left: auto; align-self: center; }

  .rp-cards { flex: 0 0 auto; display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; padding: 10px 18px; border-bottom: 1px solid #eceef1; }
  .rp-card { border: 1px solid #e3e7eb; border-radius: 6px; padding: 8px 12px; background: #fff; min-width: 0; }
  .rp-card-alerta { border-color: #e0a83a; background: #fdf9ef; }
  .rp-card-ok .rp-card-num { color: #0a6d4d; }
  .rp-card-alerta .rp-card-num { color: #b06a15; }
  .rp-card-lbl { font-size: 10.5px; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; font-weight: 600; white-space: nowrap; }
  .rp-card-num { font-size: 18px; font-weight: 600; color: #1c2024; margin-top: 2px; }
  .rp-card-obs { font-size: 11px; color: #8a939c; margin-top: 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

  .rp-corpo { flex: 1 1 auto; min-height: 0; overflow-y: auto; overflow-x: hidden; padding: 12px 18px; background: #f7f9fa; }
  .rp-msg { text-align: center; padding: 40px; color: #8a939c; }
  .rp-vazio p { max-width: 520px; margin: 12px auto 0; font-size: 13px; }
  .rp-erro { color: #a13c3c; }

  .rp-bloco { min-width: 0; max-width: 100%; overflow: hidden; box-sizing: border-box; background: #fff; border: 1px solid #e3e7eb; border-left: 4px solid #c6ccd4; border-radius: 6px; margin-bottom: 12px; }
  .rp-bloco.pronto { border-left-color: #0f8a5f; }
  .rp-bloco.pendente { border-left-color: #c0392b; }
  .rp-bloco-cab { display: flex; align-items: center; gap: 10px; padding: 9px 12px; border-bottom: 1px solid #eceef1; }
  .rp-bloco-cab input[type=checkbox] { margin: 0; width: 15px; height: 15px; }
  .rp-bloco-tit { flex: 1 1 auto; min-width: 0; display: flex; align-items: baseline; gap: 10px; cursor: pointer; white-space: nowrap; overflow: hidden; }
  .rp-bloco-tit b { font-size: 14px; color: #1c2024; overflow: hidden; text-overflow: ellipsis; }
  .rp-ident { font-size: 12px; color: #12876f; font-weight: 600; }
  .rp-linha-excel { font-size: 11px; color: #9aa3ac; }
  .rp-tag { font-size: 11px; color: #5b6570; background: #f1f3f5; border-radius: 10px; padding: 1px 8px; white-space: nowrap; }
  .rp-exp { border: 1px solid #dfe3e8; background: #fff; border-radius: 4px; width: 24px; height: 24px; color: #6b747e; cursor: pointer; padding: 0; }

  .rp-sit { display: inline-flex; align-items: center; gap: 4px; font-size: 10.5px; font-weight: 600; border-radius: 10px; padding: 1px 8px; line-height: 16px; border: 1px solid transparent; white-space: nowrap; }
  .rp-sit-ok { color: #0a6d4d; background: #fff; border-color: #b9dccd; }
  .rp-sit-pend { color: #a13c3c; background: #fdf1f1; border-color: #e4d7d7; }
  .rp-sit-neutro { color: #5b6570; background: #f1f3f5; border-color: #dfe3e8; }

  .rp-conf { display: flex; flex-wrap: wrap; gap: 6px; padding: 8px 12px; border-bottom: 1px solid #f0f1f3; }
  .rp-conf-item { display: inline-flex; min-width: 0; align-items: center; gap: 6px; max-width: 420px; font-size: 12px; border: 1px solid #e3e7eb; border-radius: 5px; padding: 3px 8px; background: #fff; }
  .rp-conf-item.ok { border-color: #b9dccd; background: #f3faf7; }
  .rp-conf-item.ok i { color: #0a6d4d; }
  .rp-conf-item.nao { border-color: #f0d9a8; background: #fdf9ef; }
  .rp-conf-item.nao i { color: #b06a15; }
  .rp-conf-item.info i { color: #7b848e; }
  .rp-conf-lbl { color: #7b848e; font-weight: 600; white-space: nowrap; }
  .rp-conf-val { color: #1c2024; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

  .rp-msgs { padding: 6px 12px; border-bottom: 1px solid #f0f1f3; }
  .rp-msg-erro { font-size: 12.5px; color: #a13c3c; padding: 2px 0; }
  .rp-msg-aviso { font-size: 12.5px; color: #8a5a00; padding: 2px 0; }

  .rp-tab { width: 100%; border-collapse: collapse; }
  .rp-tab th { background: #f7f9fa; font-size: 10.5px; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; font-weight: 600; text-align: left; padding: 6px 10px; border-bottom: 1px solid #dfe3e8; white-space: nowrap; }
  .rp-tab th.r, .rp-tab td.r { text-align: right; }
  .rp-tab td { font-size: 12.5px; color: #34495e; padding: 5px 10px; border-top: 1px solid #f0f1f3; white-space: nowrap; vertical-align: middle; }
  .rp-tab td.b { font-weight: 600; color: #1c2024; }
  .rp-tab td.hist { max-width: 280px; overflow: hidden; text-overflow: ellipsis; }
  .rp-tab td.hist.curto { max-width: 180px; }
  .rp-tab-lanc, .rp-tab-linhas { table-layout: fixed; }
  .rp-tab-lanc td, .rp-tab-linhas td, .rp-tab-lanc th, .rp-tab-linhas th { overflow: hidden; text-overflow: ellipsis; }
  .rp-tab-lanc td.hist, .rp-tab-linhas td.hist, .rp-tab-lanc td.hist.curto, .rp-tab-linhas td.hist.curto, .rp-tab td.rp-td-sit { max-width: none; }
  .rp-tab-lanc { border-bottom: 1px solid #eceef1; }
  .rp-atuais > td { white-space: normal; }
  .rp-tab-linhas tbody tr:nth-child(even) > td { background: #fbfcfd; }
  .rp-tab-linhas tfoot td { background: #f7f9fa; border-top: 1px solid #dfe3e8; overflow: visible; }
  .rp-tot-lbl { font-size: 11px; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; font-weight: 600; }
  .rp-amarelo { background: #fff6cc !important; }
  .rp-ajustado { color: #8a5a00; font-weight: 600; }
  .rp-ajustado sup { color: #b06a15; margin-left: 1px; }
  .rp-linha-erro > td { background: #fdf4f4 !important; }
  .rp-tab td.rp-td-sit { max-width: 340px; overflow: hidden; text-overflow: ellipsis; }
  .rp-erro-linha { color: #a13c3c; font-size: 12px; }
  .rp-link { color: #1f6fb2; font-size: 12px; }
  .rp-atuais > td { background: #fbfcfd; padding: 6px 12px 10px 40px; }
  .rp-tab-atual th { background: #f1f3f5; }
  .rp-linha-click { cursor: pointer; }
  .rp-linha-click:hover > td { background: #eaf5ff; }

  .rp-foot { flex: 0 0 auto; display: flex; justify-content: space-between; align-items: center; gap: 12px; padding: 12px 18px; border-top: 1px solid #dfe3e8; background: #f7f9fa; }
  .rp-foot-info { font-size: 13px; color: #5b6570; }
  .rp-acoes { display: flex; gap: 8px; }
  .rd-sair { background: #fdf1f1; border: 1px solid #e4d7d7; color: #a13c3c; font-weight: 600; }
  .rd-sair:hover { background: #fbe7e7; border-color: #d9c2c2; color: #a13c3c; }

  .rp-conf-ov { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.45); display: flex; align-items: center; justify-content: center; z-index: 5; }
  .rp-dlg { width: 640px; max-width: 94%; max-height: 82%; display: flex; flex-direction: column; background: #fff; border-radius: 8px; box-shadow: 0 12px 36px rgba(16,24,40,.3); padding: 16px 18px; }
  .rp-dlg-busca { width: 1100px; height: 70%; }
  .rp-dlg h5 { margin: 0 0 10px; font-size: 15px; font-weight: 600; color: #1c2024; }
  .rp-dlg p { font-size: 13px; color: #34495e; margin: 0 0 8px; }
  .rp-dlg-lista { flex: 1 1 auto; min-height: 0; overflow: auto; list-style: none; margin: 0 0 10px; padding: 0; border: 1px solid #eceef1; border-radius: 6px; }
  .rp-dlg-lista li { padding: 6px 10px; font-size: 12.5px; color: #34495e; border-top: 1px solid #f0f1f3; }
  .rp-dlg-lista li:first-child { border-top: none; }
  .rp-dlg-lista li small { display: block; color: #6b747e; font-size: 11.5px; margin-top: 2px; }
  .rp-dlg-perg { font-weight: 600; color: #1c2024; }
  .rp-dlg-acoes { display: flex; justify-content: flex-end; gap: 8px; margin-top: 10px; }
  .rp-busca-filtros { display: flex; align-items: flex-end; gap: 10px; margin-bottom: 10px; }
  .rp-busca-filtros .form-control { height: 30px; font-size: 12.5px; }
  .rp-busca-res { flex: 1 1 auto; min-height: 0; overflow: auto; border: 1px solid #eceef1; border-radius: 6px; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/RateioPlanilhaModal.vue